import { getPhoneSchema } from "Schemas/phoneSchema";
import type { TFunction } from "Translations/Resources";
import { z } from "zod";

export const getMerchantPartySchema = (t: TFunction) =>
  z.object({
    phone: getPhoneSchema(t),
    email: z.email(),
  });
